import { decode } from 'base-64';

export default function paramsFromUrl(param: string): any {
  const decoded = decode(new URLSearchParams(location.search).get(param)?.replace(' ', '+') ?? '');
  return decoded === '' ? '' : JSON.parse(decoded);
}
